import { EmbeddedCheckoutStrategy } from "@/contracts/EmbeddedCheckoutStrategy";
import EmbeddedCheckout, { EmbeddedCheckoutEvents } from "@/types/EmbeddedCheckout";
import { loadStripe, StripeEmbeddedCheckout as CheckoutSDK } from "@stripe/stripe-js";

export default class StripeEmbeddedCheckout implements EmbeddedCheckoutStrategy {
  private checkout: null | CheckoutSDK = null;

  destroy(): Promise<void> {
    if (this.checkout === null) {
      throw new Error("No active checkout to destroy.");
    }

    this.checkout.destroy();

    return Promise.resolve();
  }

  async mount(identifier: string, session: EmbeddedCheckout, listeners: EmbeddedCheckoutEvents): Promise<void> {
    const stripe = await loadStripe(session.publishable_key);

    if (stripe === null) {
      throw new Error("Failed to load Stripe.js");
    }

    this.checkout = await stripe.createEmbeddedCheckoutPage({
      fetchClientSecret: () => Promise.resolve(session.client_secret),
      onComplete: () => {
        listeners.onSuccess();
      },
    });

    this.checkout.mount(`#${identifier}`);

    return;
  }
}
